import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '../ThemeContext';
import coupleCheckLogo from '../assets/couple-check-logo.png';
import NotificationBell from './NotificationBell';
import './Navbar.css';

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const username = localStorage.getItem('username');
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  const { isDarkMode, toggleTheme } = useTheme();

  const handleLogout = () => {
    localStorage.removeItem('username');
    localStorage.removeItem('isLoggedIn');
    navigate('/login');
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  if (location.pathname === '/login' || location.pathname === '/signup') {
    return null;
  }

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src={coupleCheckLogo} alt="Couple Check" />
        </Link>

        <ul className="navbar-menu">
          {isLoggedIn ? (
            <>
              <li className="navbar-item">
                <Link to="/" className={`navbar-link ${isActive('/')}`}>
                  Home
                </Link>
              </li>
              <li className="navbar-item">
                <Link to="/profile" className={`navbar-link ${isActive('/profile')}`}>
                  Profile
                </Link>
              </li>
              <li className="navbar-item">
                <Link to="/add-entry" className={`navbar-link ${isActive('/add-entry')}`}>
                  Add Entry
                </Link>
              </li>
              <li className="navbar-item">
                <Link to="/view-entries" className={`navbar-link ${isActive('/view-entries')}`}>
                  View Entries
                </Link>
              </li>
              <li className="navbar-item">
                <Link to="/reports" className={`navbar-link ${isActive('/reports')}`}>
                  Reports
                </Link>
              </li>
              <li className="navbar-item">
                <Link to="/plus" className={`navbar-link plus-link ${isActive('/plus')}`}>
                  ⭐ Plus
                </Link>
              </li>
              <li className="navbar-item">
                <button onClick={toggleTheme} className="theme-toggle" title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
                  {isDarkMode ? '☀️' : '🌙'}
                </button>
              </li>
              <li className="navbar-item">
                <NotificationBell username={username} />
              </li>
              <li className="navbar-item">
                <span className="navbar-user">👤 {username}</span>
              </li>
              <li className="navbar-item">
                <button onClick={handleLogout} className="navbar-logout">
                  Logout
                </button>
              </li>
            </>
          ) : (
            <>
              <li className="navbar-item">
                <button onClick={toggleTheme} className="theme-toggle" title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
                  {isDarkMode ? '☀️' : '🌙'}
                </button>
              </li>
              <li className="navbar-item">
                <Link to="/login" className="navbar-link">
                  Login
                </Link>
              </li>
              <li className="navbar-item">
                <Link to="/signup" className="navbar-link">
                  Sign Up
                </Link>
              </li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;